import { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

import { num_word } from '../../../utils/converters'

interface IProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    partsCount: number
}

export const ModalPartsBulkConfirm = ({ isOpen, onClose, onConfirm, partsCount }: IProps) => {
    const [isChecked, setIsChecked] = useState(false)
    const partWord = num_word(partsCount, ['запчасть', 'запчасти', 'запчастей'])

    const checkboxId = 'parts-confirm-checkbox'

    return (
        <Modal show={isOpen} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title as="h6" className="fs-6">
                    Ваше действие изменит {partsCount} запчасти
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Check
                    id={checkboxId}
                    type="checkbox"
                    checked={isChecked}
                    onChange={e => setIsChecked(e.target.checked)}
                    label={
                        <label htmlFor={checkboxId} className="mb-0">
                            Я согласен, что изменю {partsCount} {partWord}
                        </label>
                    }
                />
            </Modal.Body>
            <Modal.Footer className="d-flex">
                <Button variant="primary" onClick={onConfirm} disabled={!isChecked}>
                    Применить
                </Button>
                <Button variant="secondary" onClick={onClose}>
                    Отменить
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
